<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="620px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      class="dialog-box"
      @opened="handleOpen"
      @close="handleClose"
      destroy-on-close
    >
      <div class="form_box">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="班级号" prop="classId">
            <el-input
              placeholder="请输入班级号"
              v-model.trim="formData.classId"
              clearable
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="课程" prop="content">
            <el-select
              v-model="formData.content"
              placeholder="请选择课程"
              style="width: 200px"
              clearable
              filterable
              value-key="id"
            >
              <el-option
                v-for="(item, index) in list"
                :label="item.groupName + item.day"
                :value="item.id"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="日期" prop="target">
            <el-date-picker
              v-model="formData.target"
              type="date"
              value-format="yyyy-MM-dd"
              align="center"
              style="width: 200px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="直播链接" prop="link">
            <el-input
              placeholder="请输入直播链接"
              v-model.trim="formData.link"
              clearable
            />
          </el-form-item>
          <!-- <el-form-item label="课程" prop="course">
            <el-button type="primary" @click="selectBtn">选择课程</el-button>
            <template v-if="formData.course"
              >{{ formData.course.groupName
              }}{{ formData.course.day }}</template
            >
          </el-form-item> -->
        </el-form>
        <!-- <SelectCourse ref="SelectCourse" @confirm="handleSelectCourse" /> -->
      </div>
      <span slot="footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="disabledSave"
          @click="handleConfirm"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  createLiveClass,
  updateLiveClass,
  listLivePreset,
} from "@/api/settings/liveClassSet.js";
// import SelectCourse from "./SelectCourse.vue";
export default {
  name: "LiveClassSetForm",
  components: {
    // SelectCourse,
  },
  props: {
    title: {
      type: String,
      default: "直播班级配置",
    },
  },
  data() {
    return {
      visible: false,
      isInit: false, // 第一次打开 用于请求初始化数据
      disabledSave: false,
      keyList2: [],
      formData: {
        id: undefined,
        classId: undefined,
        target: undefined,
        content: undefined,
        link: undefined,
      },
      rules: {
        classId: [{ required: true, message: "请输入班级号", trigger: "blur" }],
        target: [{ required: true, message: "请选择日期", trigger: "blur" }],
        content: [{ required: true, message: "请选择课程", trigger: "blur" }],
      },
      list: [],
    };
  },
  created() {},
  methods: {
    show(data) {
      this.visible = true;
      if (!this.list.length) {
        this.getListLivePreset();
      }
      if (data && data.id) {
        this.$nextTick(() => {
          for (let i in this.formData) {
            this.formData[i] = data[i];
          }
        });
      }
    },
    handleOpen() {
      if (!this.isInit) {
        this.isInit = true;
      }
    },
    handleClose() {
      this.$refs.formData.resetFields();
      this.formData.id = undefined;
    },
    handleConfirm() {
      if (this.disabledSave) return;
      this.disabledSave = true;
      this.$refs.formData.validate(async (valid, errObj) => {
        if (valid) {
          const formData = {
            ...this.formData,
            target: this.formData.target.substr(0, 10),
          };
          console.log(formData, "提交的表单数据");
          let req = createLiveClass;
          if (formData.id) {
            req = updateLiveClass;
          }
          const { code, message } = await req(formData);
          if (code == 200) {
            this.$message.success(message);
            this.visible = false;
            this.disabledSave = false;
            this.$emit("confirm", { isUpdate: !!formData.id });
            return;
          }
          this.$message.error(message);
          this.disabledSave = false;
        } else {
          console.log(errObj);
          const message =
            Object.values(errObj)[0][0].message || "请完善表单必填项";
          this.$message.error(message);
        }
        this.disabledSave = false;
      });
    },
    // selectBtn() {
    //   this.$refs.SelectCourse.show(this.formData.course);
    // },
    // handleSelectCourse(data) {
    //   this.formData.course = data;
    //   this.formData.content = data.content;
    //   this.$refs.formData.validateField("course");
    // },
    async getListLivePreset() {
      const { code, data: list, message } = await listLivePreset();
      if (code == 200) {
        this.list = list || [];
        return;
      }
      this.$message.error(message || code);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-box {
  ::v-deep .el-dialog__body {
    max-height: 610px;
    overflow-y: auto;
  }
}
</style>
